import { ThemeComponent } from "@/theme/ThemeComponent";
import { cart } from "@/theme/Cart";
import { Component, SimpleEvent } from '@eastsideco/salvo-ts';
import { CartMain } from "./CartMain";
import { QuantitySelector } from "../QuantitySelector/QuantitySelector";
import { debounce } from "lodash";
import { formatMoney } from '@/utils/formatting';
import { CartItem } from "@eastsideco/salvo-ts";
@Component
export class CartItems extends ThemeComponent {
    private cartMain: CartMain = this.closest('cart-main') as CartMain;
    private _onChange = new SimpleEvent<number>();
    get onChange() {
        return this._onChange.asEvent();
    }

    /**
     * Initialise.
     */
    init() {
        this.setClickTargets(this);
        this.initObserver();
        this.setVatNumber();
    }

    /**
     * Set event listeners.
     */
    setEventListeners(quantitySelectors:NodeList, removeButtons:NodeList) {
        for (const remove of removeButtons) {
            const target = remove as HTMLButtonElement;
            this.$listen(target, 'click', () => this.handleRemoveItem(target));
        }

        for (const selector of quantitySelectors) {
            const quantity = selector as QuantitySelector;
            this.$subscribe(quantity.onChange, debounce((value) => this.handleQuantity(quantity, value), 300));
        }
    }

    /** Set remove and quantity targets for click events.
     * - Refs are captured on page load, need the variables to be identifiable dynamically
     * when a new item is injected to cart.
     * @param parent - wrapper to loop through.
     */
    setClickTargets(parent: Element) {
        const quantitySelectors = parent.querySelectorAll('[data-ref="quantitySelector"]');
        const removeButtons = parent.querySelectorAll('[data-ref="removeItem"]');

        this.setEventListeners(quantitySelectors, removeButtons);
    }

    /**
     * Initiate mutation observer.
     * - check if a new item is added.
     */
    initObserver() {
        const observer = new MutationObserver(() => {
            const addedItems = this.querySelectorAll('[data-added]');
            if (addedItems.length == 0 ) { return; }

            for (const item of addedItems) {
                this.setClickTargets(item);
            }
        });
        observer.observe(this, {
            subtree: false,
            childList: true
        });

        this.setVatNumber();
    }

    /**
     * Remove item from cart.
     * @param target - remove button.
     */
    handleRemoveItem(target: HTMLElement) {
        if (target.dataset.item === undefined) { return; }

        for (const item of cart.items) {
            if (~~item.id === ~~target.dataset.item) {
                this.cartMain.updateCart('remove', item, undefined, target);
            }
        }
    }

    /**
     * Handle cart quanitty Change.
     */
    handleQuantity(selector: QuantitySelector, value:number) {
        if (selector.parentNode instanceof HTMLElement) {
            if (selector.parentNode.dataset.id == null) { return; }
            const itemId = selector.parentNode.dataset.id;

            for (const item of cart.items) {
                if (+item.id === +itemId) {
                    this.updateLinePrice(selector, item, value);
                    this.cartMain.updateCart('update', item, value);
                }
            }
        }
    }

    /** Line price - update on quantity change */
    updateLinePrice(selector:HTMLElement, item:CartItem, value:number) {
        const priceContainer = selector.closest('[data-ref="cartItemRow"]')?.querySelector('[data-ref="linePrice"]');

        if (!priceContainer) { return; }
        const newPrice = value * item.price;
        priceContainer.innerHTML = formatMoney(newPrice) as string;
    }

    setVatNumber() {
        const vatNumberInput = document.querySelector<HTMLInputElement>('[data-ref="vatNumber"]');
        if (vatNumberInput) {
            const sessionVatNumber = sessionStorage.getItem('vatNumber');
            vatNumberInput.value = sessionVatNumber || "";

            vatNumberInput.addEventListener('input', () => {
                const error = document.querySelector('.cart__vat-number .input-error');
                error ? error.remove() : null;

                const alphanumericRegex = /^[a-z0-9]+$/i;
                if (alphanumericRegex.test(vatNumberInput.value)) {
                    sessionStorage.setItem('vatNumber', vatNumberInput.value);
                }else {
                    const errorStr = `<span class="vat-error input-error">Invalid VAT number</span>`;
                    vatNumberInput.insertAdjacentHTML('afterend', errorStr);
                }
            });
        }
    }
}

